import { Duration, Instant } from "@js-joda/core";
import { useEffect, useState } from "react";
import { useCallbackRef } from "./useCallbackRef";

export default function useCountdown(onTimerEnd: () => void, targetTime: Instant) {
  const [countdown, setCountdown] = useState(getCurrentCountdown(targetTime));

  const handleOnTimerEnd = useCallbackRef(onTimerEnd);

  useEffect(() => {
    const interval = setInterval(() => {
      const nextCountdown = getCurrentCountdown(targetTime);
      if (nextCountdown.seconds() < 0) {
        clearInterval(interval);
        handleOnTimerEnd();
      } else {
        setCountdown((countdown) =>
          haveSameMinutes(countdown, nextCountdown) ? countdown : nextCountdown
        );
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [handleOnTimerEnd, targetTime]);

  return formatCountdown(countdown);
}

const haveSameMinutes = (duration1: Duration, duration2: Duration) =>
  duration1.toMinutes() === duration2.toMinutes();

const getCurrentCountdown = (targetTime: Instant) => Duration.between(Instant.now(), targetTime);

const addLeadingZero = (value: number) => ("0" + value).slice(-2);

const formatCountdown = (duration: Duration) => {
  if (duration.isNegative()) {
    return "00:00";
  }

  const hours = duration.toHours();
  const minutes = duration.minusHours(hours).toMinutes();

  return [addLeadingZero(hours), addLeadingZero(minutes)].join(":");
};
